<template>
  <div class="">
    <div class="d-flex gap-10">
     <download-selected-btn></download-selected-btn>
      <div class="file-action-btn gap-10" v-bind:class="{ 'disabled': isNoneSelected === true || complete !== true || selectedOutputs.length !== 1 || !canPreview()}" @click="openPreview()"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M12 6.5a9.77 9.77 0 0 1 8.82 5.5c-1.65 3.37-5.02 5.5-8.82 5.5S4.83 15.37 3.18 12A9.77 9.77 0 0 1 12 6.5m0-2C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5m0 5a2.5 2.5 0 0 1 0 5a2.5 2.5 0 0 1 0-5m0-2c-2.48 0-4.5 2.02-4.5 4.5s2.02 4.5 4.5 4.5s4.5-2.02 4.5-4.5s-2.02-4.5-4.5-4.5"/></svg>
        {{ 'Preview'|trans }}</div>
      <div class="file-action-btn gap-10" v-bind:class="{ 'disabled': isNoneSelected === true || complete !== true || selectedOutputs.length !== 1}" @click="openFileInfo()"><i class="far fa-info-circle"></i> FileInfo</div>
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'
import currentJob from './../../mixins/current_job.mixin'
import DownloadSelectedBtn from "../Elements/DownloadSelectedBtn.vue";
import PreviewManager from "../../manager/PreviewManager";
import FIleInfoManager from '../../manager/FIleInfoManager';
import JobManager from "../../manager/JobManager";
import OutputSelectionManager from "../../manager/OutputSelectionManager";

export default {
  name: "FileListNav",
  props: {},
  components: {DownloadSelectedBtn},
  mixins: [
    currentJob,
    store
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    openPreview() {
      if (OutputSelectionManager.getSelectedOutputs(this.currentJob).length !== 1) {
        return;
      }
      PreviewManager.openPreview(this.currentJob, OutputSelectionManager.getSelectedOutputs(this.currentJob)[0])
    },
    canPreview() {
      return PreviewManager.canPreviewSelectedOne(this.currentJob);
    },
    openFileInfo() {
      if (OutputSelectionManager.getSelectedOutputs(this.currentJob).length !== 1) {
        return;
      }
      FIleInfoManager.openFileInfo(this.currentJob, OutputSelectionManager.getSelectedOutputs(this.currentJob)[0])
    },
  },
  computed: {}
};
</script>
<style lang="scss" scoped>
.download-btn-main {
  padding: 0 20px;
}
.download-btn-dropdown {
  border-left: 2px solid #1158cd;
  height: 100%;
  align-items: center;
  display: inline-flex;
  padding: 0 30px;
}
.download-btn {
  padding: 0;
  background: #1266F1;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  gap: 10px;
  cursor: pointer;

  &:hover {
    background: #1161e5;
  }
}

.file-action-btn {
  cursor: pointer;
  background: #F2F2F2;
  border: 1px solid #CBCBCB;
  display:flex;
  align-items:center;
  justify-content: center;
  height: 35px;
  padding: 0 10px;
  border-radius: 4px;

  .dark-mode & {
    background:#383838;;
    border: 1px solid #595959;
    color: white;
    &:hover {
      background: #323232;
    }
  }
}
</style>
